import * as React from 'react';

const NotFound: React.FC = () => (
  <div>
    Not Found
  </div>
);

export default NotFound;
